
import React, { useState, useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { ThemeContext } from '../context/ThemeContext';
import { content } from '../content';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, toggleLanguage } = useContext(LanguageContext);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const headerContent = content[language].header;

  const closeMenu = () => setMenuOpen(false);

  const navLinkClasses = "hover:text-blue-500 transition-colors duration-300";
  const mobileNavLinkClasses = `text-xl ${theme === 'dark' ? 'text-gray-300 hover:text-white' : 'text-gray-700 hover:text-black'}`;

  const languageSwitch = (
    <button onClick={toggleLanguage} className="text-2xl">
      {language === 'en' ? '🇬🇪' : '🇺🇸'}
    </button>
  );

  const themeSwitch = (
    <button onClick={toggleTheme} className="text-2xl">
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );

  return (
    <>
      <header className={`sticky top-0 z-40 flex flex-wrap justify-between items-center p-4 shadow-md ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}`}>
        <h1 className="text-2xl font-bold">
          <a href="#">StudioCeiling</a>
        </h1>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-6">
          <a href="#about" className={navLinkClasses}>{headerContent.about}</a>
          <a href="#examples" className={navLinkClasses}>{headerContent.examples}</a>
          <a href="#contact" className={navLinkClasses}>{headerContent.contact}</a>
          {languageSwitch}
          {themeSwitch}
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(true)}>
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
      </header>

      {/* Mobile Sidebar Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'} shadow-lg transform ${menuOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out z-50`}
      >
        <div className="p-4 flex justify-end">
          <button onClick={closeMenu}>
            <svg className={`w-8 h-8 ${theme === 'dark' ? 'text-white' : 'text-gray-800'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <nav className="flex flex-col items-center space-y-8 mt-10">
          <a href="#about" onClick={closeMenu} className={mobileNavLinkClasses}>{headerContent.about}</a>
          <a href="#examples" onClick={closeMenu} className={mobileNavLinkClasses}>{headerContent.examples}</a>
          <a href="#contact" onClick={closeMenu} className={mobileNavLinkClasses}>{headerContent.contact}</a>
          <div onClick={closeMenu} className={mobileNavLinkClasses}>{languageSwitch}</div>
          <div onClick={closeMenu} className={mobileNavLinkClasses}>{themeSwitch}</div>
        </nav>
      </div>

       {/* Overlay */}
       {menuOpen && <div className="fixed inset-0 bg-black opacity-50 z-30 md:hidden" onClick={closeMenu}></div>}
    </>
  );
};

export default Header;
